import { FC } from "react";
import { CircleCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import StatusScreen from "./status-screen";

interface Props {
  contractId: number | string;
}

const AcceptedScreen: FC<Props> = ({ contractId }) => {
  const { t } = useTranslation(["contract-updates"]);
  return (
    <StatusScreen
      icon={<CircleCheck className="size-10 text-emerald-600" />}
      iconBg="bg-emerald-100"
      title={t("contract-updates:accepted-title", "Changes accepted!")}
      description={t(
        "contract-updates:accepted-description",
        "Thanks! The updated pricing for contract #{{contractId}} will now be applied. You can safely close this page.",
        { contractId },
      )}
    />
  );
};

export default AcceptedScreen;
